import { library } from '@fortawesome/fontawesome-svg-core'
import { fas } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome'

import '@/plugins/vue-composition-api'
import '@/styles/styles.scss'
import Vue from 'vue'
import axios from 'axios'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import router from './router'
import store from './store'

library.add(fas)
Vue.component('font-awesome-icon', FontAwesomeIcon)
Vue.config.productionTip = false

axios.defaults.baseURL = process.env.VUE_APP_API_URL || "http://127.0.0.1:8000"
console.log(process.env.VUE_APP_API_URL)

var filter = function (text, length, clamp) {
  clamp = clamp || '...';
  var node = document.createElement('div');
  node.innerHTML = text;
  var content = node.textContent;
  return content.length > length ? content.slice(0, length) + clamp : content;
}
Vue.filter('truncate', filter);

// ══════════════════════════════════════════════════════════════════
//  WEBPUSH NATIF VAPID  (topup — notifications messages)
// ══════════════════════════════════════════════════════════════════
const VAPID_PUBLIC_KEY = process.env.VUE_APP_VAPID_PUBLIC_KEY

function urlBase64ToUint8Array(b64) {
  const pad = '='.repeat((4 - b64.length % 4) % 4)
  const raw = atob((b64 + pad).replace(/-/g, '+').replace(/_/g, '/'))
  return Uint8Array.from([...raw].map(c => c.charCodeAt(0)))
}

function getCsrfToken() {
  return document.cookie.split(';')
    .map(c => c.trim()).find(c => c.startsWith('csrftoken='))
    ?.split('=')[1] ?? ''
}

function detectBrowser() {
  const ua = navigator.userAgent
  if (ua.includes('Firefox'))  return 'firefox'
  if (ua.includes('Opera'))    return 'opera'
  return 'chrome'
}

async function initWebPush() {
  if (!('serviceWorker' in navigator) || !('PushManager' in window)) return
  if (Notification.permission === 'denied') return

  try {
    const reg = await navigator.serviceWorker.register('/sw.js', { scope: '/' })

    navigator.serviceWorker.addEventListener('message', (e) => {
      if (e.data?.type === 'JOUER_SON') jouerSon()
    })

    if (Notification.permission !== 'granted') {
      const perm = await Notification.requestPermission()
      if (perm !== 'granted') return
    }

    let sub = await reg.pushManager.getSubscription()
    if (!sub) {
      sub = await reg.pushManager.subscribe({
        userVisibleOnly:      true,
        applicationServerKey: urlBase64ToUint8Array(VAPID_PUBLIC_KEY),
      })
    }

    // Récupérer le token d'authentification
    const token = store.state.token || localStorage.getItem('token') || ''

    await axios.post('/api/v1/webpush/subscribe/', {
      status_type:  'subscribe',
      subscription: sub.toJSON(),
      group:        'topup_users', // 🌟 Groupe adapté pour l'écosystème TopUp
      browser:      detectBrowser(),
    }, {
      headers: {
        'Content-Type':  'application/json',
        'Authorization': `Token ${token}`, // 🌟 Token Auth Djoser
        'X-CSRFToken':   getCsrfToken(),
      }
    })

    console.log('✅ TopUp WebPush abonné')
  } catch (e) {
    console.warn('WebPush TopUp:', e)
  }
}

function jouerSon() {
  try {
    const ctx  = new (window.AudioContext || window.webkitAudioContext)()
    const osc  = ctx.createOscillator()
    const gain = ctx.createGain()
    osc.connect(gain); gain.connect(ctx.destination)
    osc.frequency.value = 750; osc.type = 'sine' // Fréquence d'origine conservée
    gain.gain.setValueAtTime(0.8, ctx.currentTime)
    gain.gain.exponentialRampToValueAtTime(0.001, ctx.currentTime + 0.5)
    osc.start(); osc.stop(ctx.currentTime + 0.55)
  } catch (e) {
    console.warn('Impossible de jouer le son topup:', e)
  }
}

// 🌟 Exposer globalement pour App.vue
window._initWebPush = initWebPush
// ══════════════════════════════════════════════════════════════════

new Vue({
  router,
  axios,
  store,
  vuetify,
  render: h => h(App),
}).$mount('#app')
